import type { MessageKey } from '../en';

export const hi: Partial<Record<MessageKey, string>> = {
  "defaults.accuracy.desc": "नए इतिहास बिंदुओं के लिए उपयोग की सटीकता",
  "defaults.accuracy.title": "डिफ़ॉल्ट GPS सटीकता",
  "defaults.actual.desc": "सिमुलेशन के दौरान जगह खोजने के लिए उपयोग होता है",
  "defaults.actual.empty": "अभी सहेजा नहीं",
  "defaults.actual.emptyHint": "स्थान की अनुमति दें और बिना सिमुलेशन ऐप खोलकर इसे कैप्चर करें।",
  "defaults.actual.pending": "फ़ोन यह स्थान सहेजता है। सिंक अभी जुड़ा नहीं है।",
  "defaults.actual.refresh": "अभी अपडेट करें",
  "defaults.actual.title": "आपका वास्तविक स्थान",
  "defaults.browserChip": "यह ब्राउज़र",
  "defaults.close": "बंद करें",
  "defaults.color.desc": "नए मार्गों की रेखा का रंग",
  "defaults.color.group": "मार्ग रंग",
  "defaults.color.title": "मार्ग रंग",
  "defaults.degrees": "{n}°",
  "defaults.format.dayMonthYear": "तारीख, वर्ष · 12 घंटे",
  "defaults.format.dayShort": "दिन और तारीख · 12 घंटे",
  "defaults.format.eu": "EU तारीख · 24 घंटे",
  "defaults.format.fullDay": "पूरी तारीख · 12 घंटे",
  "defaults.format.iso": "ISO तारीख · 24 घंटे",
  "defaults.format.monthFirst": "महीना पहले · 24 घंटे",
  "defaults.format.shortDayYear": "दिन, तारीख, वर्ष · 24 घंटे",
  "defaults.format.timeFirst": "समय पहले · 24 घंटे",
  "defaults.format.us": "US तारीख · 12 घंटे",
  "defaults.format.withSeconds": "सेकंड सहित · 12 घंटे",
  "defaults.itinAccuracy.desc": "नए खंडों की GPS सटीकता",
  "defaults.itinAccuracy.title": "सटीकता",
  "defaults.itinerary.desc": "नए खंडों के डिफ़ॉल्ट",
  "defaults.itinerary.title": "मार्ग",
  "defaults.joyAccuracy.desc": "जॉयस्टिक सत्र बनाते समय शुरुआती GPS सटीकता",
  "defaults.joyAccuracy.title": "डिफ़ॉल्ट GPS सटीकता",
  "defaults.joyName.desc": "नए जॉयस्टिक सत्रों का डिफ़ॉल्ट नाम",
  "defaults.joyName.dialogTitle": "सत्र नाम का प्रारूप चुनें",
  "defaults.joyName.title": "तारीख प्रारूप",
  "defaults.joySpeed.desc": "जॉयस्टिक सत्र बनाते समय शुरुआती गति",
  "defaults.joySpeed.title": "डिफ़ॉल्ट गति",
  "defaults.joyUnit.desc": "जॉयस्टिक गति km/h या mph में दिखाता और सेट करता है",
  "defaults.joystick.desc": "जॉयस्टिक सत्रों के डिफ़ॉल्ट",
  "defaults.joystick.title": "जॉयस्टिक",
  "defaults.kilometers": "{n} किमी",
  "defaults.map.desc": "नए मानचित्र कैसे खुलते हैं",
  "defaults.map.title": "Google Map",
  "defaults.mapTheme.desc": "नई मानचित्र स्क्रीन का रूप",
  "defaults.mapTheme.group": "मानचित्र थीम",
  "defaults.mapTheme.title": "मानचित्र थीम",
  "defaults.marker.car": "कार",
  "defaults.marker.desc": "जॉयस्टिक सत्र बनाते समय उपयोग होता है। हर सत्र में बदला जा सकता है।",
  "defaults.marker.group": "डिफ़ॉल्ट मार्कर",
  "defaults.marker.maps": "Maps",
  "defaults.marker.title": "डिफ़ॉल्ट मार्कर",
  "defaults.marker.waze": "Waze",
  "defaults.meters": "{n} मी",
  "defaults.nameFormat.desc": "स्थिर बिंदुओं का डिफ़ॉल्ट नाम",
  "defaults.nameFormat.dialogSubtitle": "पूर्वावलोकन आज की तारीख उपयोग करता है। नए बिंदुओं के लिए संक्षिप्त प्रारूप चुनें।",
  "defaults.nameFormat.dialogTitle": "बिंदु नाम का प्रारूप चुनें",
  "defaults.nameFormat.group": "तारीख प्रारूप",
  "defaults.nameFormat.title": "तारीख प्रारूप",
  "defaults.overlay.itinerary.desc": "जब मार्ग सिमुलेशन पृष्ठभूमि में जारी रहे तो तैरता प्लेयर",
  "defaults.overlay.itinerary.title": "ऑटो मार्ग",
  "defaults.overlay.joystick.desc": "जब सत्र पृष्ठभूमि में जारी रहे तो तैरता जॉयस्टिक",
  "defaults.overlay.joystick.title": "जॉयस्टिक",
  "defaults.overlay.playlist.desc": "जब सूची सिमुलेशन पृष्ठभूमि में जारी रहे तो तैरता प्लेयर",
  "defaults.overlay.playlist.title": "सूची",
  "defaults.overlay.stationary.desc": "जब स्थिर सिमुलेशन पृष्ठभूमि में जारी रहे तो तैरता प्लेयर",
  "defaults.overlay.stationary.title": "स्थिर बिंदु",
  "defaults.plAccuracy.desc": "हर सूची पिन पर लागू GPS सटीकता",
  "defaults.plAccuracy.title": "प्रति आइटम सटीकता",
  "defaults.player.desc": "ओवरले प्लेयर और सिमुलेशन नियंत्रण",
  "defaults.player.title": "प्लेयर",
  "defaults.playlist.desc": "नए सूची पिन के डिफ़ॉल्ट",
  "defaults.playlist.title": "सूची",
  "defaults.polyline.desc": "जॉयस्टिक सत्र के दौरान खींचे मार्ग का डिफ़ॉल्ट रंग।",
  "defaults.polyline.group": "पॉलीलाइन रंग",
  "defaults.polyline.title": "डिफ़ॉल्ट पॉलीलाइन रंग",
  "defaults.range.accuracyMax": "300 मी",
  "defaults.range.accuracyMin": "0 मी",
  "defaults.range.itinAccuracyMax": "100",
  "defaults.range.itinAccuracyMin": "1",
  "defaults.range.joyAccuracyMax": "100 मी",
  "defaults.range.joyAccuracyMin": "1 मी",
  "defaults.range.plAccuracyMax": "500 मी",
  "defaults.range.plAccuracyMin": "0 मी",
  "defaults.range.searchMax": "50 किमी",
  "defaults.range.searchMin": "3 किमी",
  "defaults.range.tiltMax": "65°",
  "defaults.range.tiltMin": "0°",
  "defaults.range.timeMax": "600 से",
  "defaults.range.timeMin": "0 से",
  "defaults.range.zoomMax": "20",
  "defaults.range.zoomMin": "10",
  "defaults.reset": "रीसेट",
  "defaults.search.itinerary": "मानचित्र केंद्र के आस-पास के परिणाम पहले आते हैं",
  "defaults.search.playlist": "मानचित्र केंद्र के आस-पास के परिणाम पहले आते हैं",
  "defaults.search.stationary": "आपके पिन के आस-पास के परिणाम पहले आते हैं",
  "defaults.search.title": "खोज त्रिज्या",
  "defaults.seconds": "{n} से",
  "defaults.section.appearance": "रूप",
  "defaults.section.camera": "कैमरा",
  "defaults.section.history": "इतिहास",
  "defaults.section.location": "स्थान संदर्भ",
  "defaults.section.map": "मानचित्र",
  "defaults.section.motion": "गति",
  "defaults.section.overlay": "ओवरले प्लेयर",
  "defaults.section.playlist": "सूची",
  "defaults.section.search": "खोज",
  "defaults.section.style": "शैली",
  "defaults.section.view": "मानचित्र",
  "defaults.sectionDefaults": "ऐप डिफ़ॉल्ट",
  "defaults.sectionDefaultsDesc": "तेज़ और सहज अनुभव के लिए डिफ़ॉल्ट सेट करें",
  "defaults.sectionPlayer": "प्लेयर",
  "defaults.sectionPlayerDesc": "ओवरले और प्लेबैक सेटिंग्स",
  "defaults.speed.desc": "नए खंडों की प्लेबैक गति",
  "defaults.speed.title": "डिफ़ॉल्ट गति",
  "defaults.speedValue": "{n} {unit}",
  "defaults.stationary.desc": "नए मानचित्र बिंदुओं के डिफ़ॉल्ट",
  "defaults.stationary.title": "स्थिर बिंदु",
  "defaults.summary.playerAll": "सभी ओवरले चालू",
  "defaults.summary.playerOff": "ओवरले बंद",
  "defaults.summary.playerSome": "4 में से {on} चालू",
  "defaults.summary.zoom": "ज़ूम {n}",
  "defaults.syncNote": "अभी इस ब्राउज़र में सहेजा गया है। सिंक जुड़ने के बाद फ़ोन ऐप ये मान उपयोग करेगा।",
  "defaults.theme.night": "रात",
  "defaults.theme.nightDesc": "कम रोशनी और रात के सत्रों के लिए गहरे मानचित्र रंग।",
  "defaults.theme.retro": "रेट्रो",
  "defaults.theme.retroDesc": "गर्म पुराने टोन, क्लासिक मानचित्र जैसा एहसास।",
  "defaults.theme.silver": "सिल्वर",
  "defaults.theme.silverDesc": "हल्का धूसर रूप, दिन की रोशनी में अच्छा।",
  "defaults.theme.standard": "स्टैंडर्ड",
  "defaults.theme.standardDesc": "क्लासिक Google Maps रंग, परिचित हरे और नीले के साथ।",
  "defaults.tilt.desc": "मानचित्र स्क्रीन पर कैमरा कोण",
  "defaults.tilt.title": "डिफ़ॉल्ट कैमरा झुकाव",
  "defaults.time.desc": "अगले पिन पर जाने से पहले प्रतीक्षा",
  "defaults.time.title": "प्रति आइटम समय",
  "defaults.tray.group": "ट्रे ऊँचाई",
  "defaults.tray.large": "बड़ी",
  "defaults.tray.medium": "मध्यम",
  "defaults.tray.playlistDesc": "मानचित्र पर दिखने वाला सूची पैनल",
  "defaults.tray.small": "छोटी",
  "defaults.tray.stationaryDesc": "मानचित्र पर दिखने वाले पैनल का आकार",
  "defaults.tray.title": "ट्रे ऊँचाई",
  "defaults.unit.group": "गति इकाई",
  "defaults.unit.itineraryDesc": "मार्ग मॉड्यूल में गति km/h या mph में दिखाता है",
  "defaults.unit.kmh": "km/h",
  "defaults.unit.mph": "mph",
  "defaults.unit.title": "गति इकाई",
  "defaults.view.grid": "ग्रिड",
  "defaults.view.group": "दृश्य",
  "defaults.view.historyDesc": "सहेजे बिंदु कैसे दिखते हैं",
  "defaults.view.historyTitle": "इतिहास दृश्य",
  "defaults.view.list": "सूची",
  "defaults.view.playlistDesc": "सहेजी सूचियाँ कैसे दिखती हैं",
  "defaults.view.playlistTitle": "सूची दृश्य",
  "defaults.zoom.desc": "नए मानचित्रों का शुरुआती ज़ूम",
  "defaults.zoom.title": "डिफ़ॉल्ट ज़ूम स्तर",
  "language.defaultBadge": "डिफ़ॉल्ट",
  "language.empty": "इस खोज से कोई भाषा मेल नहीं खाती।",
  "language.lead": "अंग्रेज़ी (संयुक्त राज्य) डिफ़ॉल्ट है। आपकी पसंद इस ब्राउज़र में सहेजी जाती है।",
  "language.listLabel": "भाषाएँ",
  "language.preview": "नकली स्थान, सूचियाँ और मार्ग।",
  "language.previewLabel": "पूर्वावलोकन",
  "language.searchLabel": "भाषाएँ खोजें",
  "language.searchPlaceholder": "भाषाएँ खोजें",
  "nav.account": "खाता",
  "nav.account.desc": "प्रोफ़ाइल, Premium और साइन-इन।",
  "nav.analytics": "विश्लेषण",
  "nav.analytics.desc": "MockLoc गतिविधि, नेटवर्क उपयोग और सिंक स्थिति समझें।",
  "nav.articles": "लेख",
  "nav.articles.desc": "सेटअप, प्लेबैक और सिंक की गाइड।",
  "nav.backup": "बैकअप और सिंक",
  "nav.backup.desc": "क्लाउड बैकअप और सिंक्रनाइज़ेशन की स्थिति।",
  "nav.coins": "Mock Coins",
  "nav.coins.desc": "मॉड्यूल और गतिविधि के अनुसार सिक्कों के उपयोग का पूरा विवरण।",
  "nav.dashboard": "डैशबोर्ड",
  "nav.dashboard.desc": "स्थान, सूचियों, मार्गों और खाता गतिविधि का सार।",
  "nav.devices": "डिवाइस प्रबंधित करें",
  "nav.devices.desc": "अपने MockLoc खाते में साइन इन डिवाइस देखें।",
  "nav.help": "सहायता और समर्थन",
  "nav.help.desc": "बातचीत ट्रैक करें और MockLoc टीम से मदद लें।",
  "nav.history": "स्थान इतिहास",
  "nav.history.desc": "वे जगहें जिन्हें इस खाते ने सिम्युलेट किया।",
  "nav.itinerary": "मार्ग",
  "nav.itinerary.desc": "सहेजे मार्ग बनाएँ, संपादित करें और प्रबंधित करें।",
  "nav.joystick": "जॉयस्टिक सत्र",
  "nav.joystick.desc": "प्लेबैक मार्ग, आँकड़े और सहेजे जॉयस्टिक सत्र।",
  "nav.notifications": "सूचनाएँ",
  "nav.notifications.desc": "सिंक, बैकअप और उत्पाद की सूचनाएँ।",
  "nav.playlist": "सूचियाँ",
  "nav.playlist.desc": "नकली स्थानों के क्रमबद्ध समूह।",
  "nav.settings": "सेटिंग्स",
  "nav.settings.desc": "थीम, भाषा और मोबाइल ऐप के डिफ़ॉल्ट।",
  "nav.stationary": "स्थिर बिंदु",
  "nav.stationary.desc": "इस खाते पर सहेजे स्थिर नकली स्थान।",
  "nav.whatsNew": "ऐप में नया",
  "nav.whatsNew.desc": "MockLoc में नए अपडेट, सुधार और बेहतरी।",
  "settings.back": "सेटिंग्स",
  "settings.backDefaults": "ऐप डिफ़ॉल्ट",
  "settings.defaults.shellDesc": "वे मान जिनका फ़ोन ऐप मानचित्र, बिंदु, मार्ग और प्लेबैक के लिए उपयोग करता है।",
  "settings.defaults.shellTitle": "ऐप डिफ़ॉल्ट",
  "settings.home.defaults.desc": "फ़ोन ऐप के मानचित्र, बिंदु, सूची, मार्ग, जॉयस्टिक और प्लेयर डिफ़ॉल्ट।",
  "settings.home.defaults.title": "मोबाइल ऐप डिफ़ॉल्ट",
  "settings.home.language.desc": "मेनू, पेज शीर्षक और सेटिंग्स की भाषा चुनें।",
  "settings.home.language.title": "भाषा सेटिंग्स",
  "settings.home.theme.desc": "इस ब्राउज़र के लिए टेक्स्ट आकार, रंग, हल्का या गहरा और फ़ॉन्ट।",
  "settings.home.theme.title": "थीम सेटिंग्स",
  "settings.language.shellDesc": "इस वेबसाइट की भाषा चुनें।",
  "settings.language.shellTitle": "भाषा",
  "settings.theme.shellDesc": "इस ब्राउज़र के लिए टेक्स्ट आकार, रंग, हल्का या गहरा और फ़ॉन्ट।",
  "settings.theme.shellTitle": "थीम",
  "shell.account": "खाता",
  "shell.accountMenu": "खाता मेनू",
  "shell.accountMenuNamed": "खाता मेनू, {name}",
  "shell.closeMenu": "मेनू बंद करें",
  "shell.collapseSidebar": "साइडबार समेटें",
  "shell.dashboardSubtitle": "नकली स्थान, सूचियाँ, मार्ग और बाकी सब एक जगह प्रबंधित करें।",
  "shell.devicesLimit": "अधिकतम 3 डिवाइस पर उपयोग",
  "shell.expandSidebar": "साइडबार खोलें",
  "shell.goPremium": "Premium लें",
  "shell.logOut": "लॉग आउट",
  "shell.mainNav": "मुख्य नेविगेशन",
  "shell.noMatches": "कोई मेल नहीं",
  "shell.notifications": "सूचनाएँ",
  "shell.notificationsUnread": "सूचनाएँ, {count} अपठित",
  "shell.openMenu": "मेनू खोलें",
  "shell.pages": "पेज",
  "shell.recent": "हाल के",
  "shell.searchLabel": "स्थान, सूचियाँ, मार्ग, लेख खोजें",
  "shell.searchPlaceholder": "स्थान, सूचियाँ, मार्ग, लेख खोजें...",
  "shell.searchResults": "खोज परिणाम",
  "shell.tagline": "नकली स्थान, आसान तरीके से",
  "shell.themeDarkTitle": "गहरी थीम",
  "shell.themeLightTitle": "हल्की थीम",
  "shell.themeToDark": "गहरी थीम पर जाएँ",
  "shell.themeToLight": "हल्की थीम पर जाएँ",
  "shell.there": "आप",
  "shell.unlimitedCoins": "असीमित सिक्के",
  "shell.unlimitedEverything": "सब कुछ असीमित",
  "shell.upgradeNow": "अभी अपग्रेड करें",
  "shell.viewAllNotifications": "सभी सूचनाएँ देखें",
  "shell.welcome": "वापसी पर स्वागत है, {name}!",
  "theme.builtin": "बिल्ट-इन",
  "theme.changesLabel": "क्या बदलता है।",
  "theme.color.accent.changes": "ब्रांड सोना और हल्की सुनहरी सतहें, चित्रों के छोटे विवरण सहित।",
  "theme.color.accent.title": "एक्सेंट",
  "theme.color.accent.where": "साइन-इन, लेख और बैज पर सुनहरे हाइलाइट।",
  "theme.color.danger.changes": "लाल त्रुटि टेक्स्ट और विनाशकारी क्रियाएँ।",
  "theme.color.danger.title": "खतरा",
  "theme.color.danger.where": "त्रुटियाँ, हटाना और अपठित बिंदु।",
  "theme.color.info.changes": "हल्के और गहरे में जानकारी के लिए उपयोग किया नीला।",
  "theme.color.info.title": "जानकारी",
  "theme.color.info.where": "नीली स्थिति, जानकारी लिंक और जानकारी चिह्न।",
  "theme.color.lead": "बिल्ट-इन रंग हल्के और गहरे में अलग रहते हैं, जब तक आप एक न चुनें। आपकी पसंद दोनों थीम में लागू होती है। बिंदु, सूची या मार्ग पर सहेजा रंग वैसे ही रहता है।",
  "theme.color.primary.changes": "ठोस बैंगनी, हल्का बैंगनी टेक्स्ट और मुलायम बैंगनी सतहें।",
  "theme.color.primary.title": "प्राथमिक",
  "theme.color.primary.where": "बटन, सक्रिय मेनू आइटम, लिंक और ब्रांड बैंगनी।",
  "theme.color.success.changes": "हरा स्थिति टेक्स्ट और सफलता चिह्न।",
  "theme.color.success.title": "सफलता",
  "theme.color.success.where": "सिंक हुआ, पूर्ण और सकारात्मक स्थिति।",
  "theme.color.title": "रंग",
  "theme.color.warning.changes": "एम्बर चेतावनियाँ और सिक्कों पर उपयोग किया सोना।",
  "theme.color.warning.title": "चेतावनी",
  "theme.color.warning.where": "अलर्ट, सिक्का चिह्न और Premium हाइलाइट।",
  "theme.colorAria": "रंग {title}",
  "theme.custom": "कस्टम",
  "theme.face.arialBold": "Arial Bold",
  "theme.face.arialRegular": "Arial Regular",
  "theme.face.arialSynth": "Arial से बनाया गया",
  "theme.face.gsBold": "Google Sans Bold",
  "theme.face.gsRegular": "Google Sans Regular",
  "theme.face.helveticaOther": "Helvetica या बनाया गया",
  "theme.face.helveticaRegular": "Helvetica Regular",
  "theme.face.inter": "Inter {weight}",
  "theme.font.arial.note": "Regular और Bold इंस्टॉल फ़ॉन्ट हैं। बाकी वज़न बनाए जाते हैं।",
  "theme.font.google-sans.note": "Regular फ़ाइल 400 और 500 कवर करती है। Bold फ़ाइल 600 से 900 कवर करती है।",
  "theme.font.group": "फ़ॉन्ट",
  "theme.font.helvetica.note": "इस डिवाइस पर Helvetica, फिर Helvetica Neue, फिर Arial।",
  "theme.font.inter.note": "आज साइट यही फ़ॉन्ट उपयोग करती है। Regular से Black तक लोड हैं।",
  "theme.font.lead": "पूरी साइट एक फ़ॉन्ट परिवार उपयोग करती है। Inter चुनने पर मार्केटिंग शीर्षक फिर Plus Jakarta Sans बन जाते हैं। नीचे वही वज़न हैं जिनका इंटरफ़ेस पहले से उपयोग करता है।",
  "theme.font.sample": "नकली स्थान, आसान तरीके से",
  "theme.font.title": "फ़ॉन्ट",
  "theme.hexAria": "हेक्स {title}",
  "theme.lead": "इस ब्राउज़र के लिए टेक्स्ट आकार, रंग, हल्का या गहरा और फ़ॉन्ट चुनें। 100% आज की स्क्रीन के बराबर है। यहाँ के उदाहरण और बाकी साइट साथ बदलते हैं।",
  "theme.manager": "थीम प्रबंधन",
  "theme.mode.dark": "गहरा",
  "theme.mode.darkHint": "गहरी सतहें और हल्का टेक्स्ट।",
  "theme.mode.group": "थीम",
  "theme.mode.lead": "ऊपरी पट्टी के बटन जैसा ही हल्का या गहरा विकल्प।",
  "theme.mode.light": "हल्का",
  "theme.mode.lightHint": "हल्की सतहें और गहरा टेक्स्ट।",
  "theme.mode.title": "थीम",
  "theme.previewBody": "इस खाते पर सहेजे स्थान।",
  "theme.previewBold": "सूची तैयार",
  "theme.previewHelp": "नकली स्थानों के क्रमबद्ध समूह।",
  "theme.previewKicker": "लाइव पूर्वावलोकन",
  "theme.previewTitle": "नकली स्थान",
  "theme.reset": "रीसेट",
  "theme.resetAll": "सब रीसेट करें",
  "theme.resetColors": "रंग रीसेट करें",
  "theme.resetFont": "फ़ॉन्ट रीसेट करें",
  "theme.resetText": "टेक्स्ट रीसेट करें",
  "theme.sizeAria": "{title} का आकार",
  "theme.text.bold.changes": "15 px से 18 px तक का टेक्स्ट।",
  "theme.text.bold.sample": "Premium लें",
  "theme.text.bold.title": "बोल्ड",
  "theme.text.bold.where": "कार्ड शीर्षक, ब्रांड नाम, अनुभाग शीर्षक और बड़े बटन।",
  "theme.text.descriptive.changes": "12 px से 13 px तक का टेक्स्ट।",
  "theme.text.descriptive.sample": "नकली स्थानों के क्रमबद्ध समूह।",
  "theme.text.descriptive.title": "वर्णनात्मक",
  "theme.text.descriptive.where": "उपशीर्षक, सहायता टेक्स्ट, बैज, फ़ुटर और द्वितीयक पंक्तियाँ।",
  "theme.text.header.changes": "20 px और उससे बड़ा टेक्स्ट।",
  "theme.text.header.sample": "स्थिर बिंदु",
  "theme.text.header.title": "हेडर",
  "theme.text.header.where": "पेज शीर्षक, बड़े शीर्षक, खाली अवस्था के शीर्षक और सिक्का शेष जैसे बड़े अंक।",
  "theme.text.lead": "हर भूमिका का एक साझा आकार है। उदाहरण उसी भूमिका को दिखाता है। इस पेज के स्लाइडर उपयोग में आसान रहें, इसलिए उनका आकार स्थिर रहता है।",
  "theme.text.normal.changes": "14 px का टेक्स्ट।",
  "theme.text.normal.sample": "इस खाते पर सहेजे स्थान।",
  "theme.text.normal.title": "सामान्य",
  "theme.text.normal.where": "नेविगेशन लेबल, सामान्य बटन, सूची शीर्षक और छोटे सार।",
  "theme.text.other.changes": "9 px से 11 px तक का टेक्स्ट। 9 px से छोटे निशान स्थिर रहते हैं।",
  "theme.text.other.sample": "2 घंटे पहले अपडेट",
  "theme.text.other.title": "अन्य",
  "theme.text.other.where": "छोटे लेबल, समय, चार्ट लेबल और कैप्शन।",
  "theme.text.title": "टेक्स्ट",
  "theme.weight.black": "Black",
  "theme.weight.bold": "Bold",
  "theme.weight.extrabold": "Extra bold",
  "theme.weight.medium": "Medium",
  "theme.weight.regular": "Regular",
  "theme.weight.sample": "नकली स्थान, सूचियाँ और मार्ग",
  "theme.weight.semibold": "Semibold",
  "theme.whereLabel": "कहाँ उपयोग होता है।",
};
